/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authClusterReissueOwnerKey } from "../../funcs/authClusterReissueOwnerKey.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ReissueOwnerKeyRequest$inboundSchema,
};

export const tool$authClusterReissueOwnerKey: ToolDefinition<typeof args> = {
  name: "auth-cluster-reissue-owner-key",
  description: `Re-issue an org owner key (recovery)

Mint a fresh owner-bound key for an org whose credential was lost. Cluster-admin only (\`write:cluster\`). Defaults to the org's oldest human owner and oldest team; \`userId\` / \`teamId\` override.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authClusterReissueOwnerKey(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
